module.exports = __webpack_public_path__ + "img/hannah-event-banner.e599b435.png";